import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Col, Card, CardBody, CardFooter, Table, Label, Spinner } from "reactstrap";
import { H3, H6, Image } from "../../../AbstractElements";
import PaginationComponent from "../../../Component/Learning/Common/Pagination";
import { fetchAdmin as fetchDetailAdmin } from "./AdminUtils";

const AdminContain = () => {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [paginationData, setPaginationData] = useState({ current_page: 1 });
    const [isLoading, setIsLoading] = useState(true);
    const [refetch, setRefetch] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        const fetchAdmin = async () => {
            try {
                const data = await fetchDetailAdmin(dispatch, { page: paginationData.current_page });
                setData(data.data);
                setPaginationData(data.pagination);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchAdmin();
        window.scrollTo(0, 0);
    }, [refetch]);

    const handlePagination = (page) => {
        setPaginationData((prev) => ({ ...prev, current_page: page }));
        setRefetch((prev) => !prev);
    };

    const handleNextPagination = () => {
        if (paginationData.current_page < paginationData.last_page) {
            setPaginationData((prev) => ({ ...prev, current_page: paginationData.current_page + 1 }));
            setRefetch((prev) => !prev);
        }
    };

    const handleBackPagination = () => {
        if (paginationData.current_page > 1) {
            setPaginationData((prev) => ({ ...prev, current_page: paginationData.current_page - 1 }));
            setRefetch((prev) => !prev);
        }
    };

    return (
        <>
            {isLoading ? (
                <Col lg="12" className="text-center">
                    <Spinner className="loader-30" />
                    <H6 className="sub-title mb-0">Data Loading...</H6>
                </Col>
            ) : data.length > 0 ? (
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <Table bordered striped hover>
                                <thead>
                                    <tr className="bg-primary text-light text-center">
                                        <th style={{ width: "5%" }}>No</th>
                                        <th>Nama Admin</th>
                                        <th>Role</th>
                                        <th style={{ width: "15%" }}>Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={`admin-${index}`} className="table-light">
                                            <td>{paginationData.from + index}</td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <Image
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            borderRadius: "50%",
                                                            border: "1px solid #eee",
                                                            marginRight: "5px",
                                                            filter: item.status === "inactive" ? "grayscale(100%)" : "none",
                                                        }}
                                                        src={item.photo_profile}
                                                        alt={item.name}
                                                    />
                                                    {item.status === "inactive" && (
                                                        <span className="badge bg-danger ms-2">Inactive</span>
                                                    )}
                                                    <div>
                                                        <p className="fw-bold mb-0">{item.name}</p>
                                                        <Label>{item.email || "-"}</Label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{item.role}</td>
                                            <td className="text-center">
                                                <Link to={`${process.env.PUBLIC_URL}/admin/detail/${item.id}`} className="p-1">
                                                    <i className="fa fa-info-circle fa-lg"></i>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </CardBody>
                        <CardFooter>
                            {paginationData && (
                                <PaginationComponent
                                    pagination={paginationData}
                                    handleClickPagination={handlePagination}
                                    handleNextPagination={handleNextPagination}
                                    handleBackPagination={handleBackPagination}
                                />
                            )}
                        </CardFooter>
                    </Card>
                </Col>
            ) : (
                <Col lg="12" className="text-center">
                    <H3 className="sub-title mb-5">Data Tidak Ditemukan</H3>
                </Col>
            )}
        </>
    );
};

export default AdminContain;